import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BillingManagementService } from '../../../service/billing-management.service';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { BusinessEnabledOption, CommunicationTemplate, InteractionType, KeyValues5, LocalService, OtpType, PageKey, RelationShipRole, Status, TriggeredEvent, Wrappers10 } from '../../../service/local.service';
import { KeyValueId } from 'src/app/supporting/receiptPrint';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ReceiptTemplateSelectorComponent } from 'src/app/shared/receipt-template-selector/receipt-template-selector.component';

@Component({
  selector: 'app-billings',
  templateUrl: './billings.component.html',
  styleUrls: ['./billings.component.scss']
})
export class BillingsComponent implements OnInit {
  OtpType = OtpType; CommunicationTemplate = CommunicationTemplate;
  lstSectionConfigKeys: string[] = ["billings", "table"]; maxBodyHeight = 0;
  businessId: string = ''; wrapper: Wrappers10; ctryCode: string = ''; interactionType = 0; tokenNumber = ''; selectedStatus = '0'; isOpenConfirmationBox = false;
  isShowOtpPopup: boolean = false; isExcluded: boolean = false; isExcludedEnabled: boolean = false; isSendToPhoneEnabled = false; isLockPreviewReceipt = false;
  selectedUserId: string = ''; relationShipType: InteractionType = InteractionType.Business; relationShipRole: RelationShipRole = RelationShipRole.EndCustomer;
  isDedicatedStorageAvailable: boolean = false; isOpenSendToPhone: boolean = false; selectedId: string = '';

  isActionPopupOpen: boolean = false; actionTitle: string = ''; moreActionItems: KeyValues5[] = [];

  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private route: ActivatedRoute, private billingManagementService: BillingManagementService, private router: Router, private languageManagementService: LanguageManagementService, private configurationManagementService: ConfigurationManagementService, private modalService: NgbModal) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.interactionType = parseInt(routeParams.interactionType);
      this.businessId = routeParams.businessId;
      this.selectedUserId = '';
      if (this.interactionType == InteractionType.Business || this.interactionType == InteractionType.Bill_PnixSoft)
        this.configurationManagementService.ensurePageActions(PageKey.BillingsBusiness, this.businessId);
      else
        this.configurationManagementService.ensurePageActions(PageKey.Billings);
      if (this.interactionType != InteractionType.User && (this.businessId == '' || this.businessId == '0')) {
        this.localService.redirectToSeller();
      } else {
        this.localService.saveUrl();
        this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType, routeParams.businessId, false, this.interactionType == InteractionType.User ? routeParams.businessId : '');
        this.ctryCode = routeParams.ctryCode;
        this.businessId = routeParams.businessId ? routeParams.businessId : '';
        this.onInitiate();
      }
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onInitiate() {
    setTimeout(() => {
      this.isDedicatedStorageAvailable = this.localService.isDedicatedStorageAvailable(this.businessId);
    }, 1000);
    this.onLoad();
  }

  onLoad() {
    this.isExcludedEnabled = this.localService.isBusinessOptionEnabled(this.businessId, BusinessEnabledOption.IsExcludedPricingEnabled);
    this.isSendToPhoneEnabled = this.localService.isBusinessOptionEnabled(this.businessId, BusinessEnabledOption.ShowSmsButtonInBillingPage);
    this.isLockPreviewReceipt = this.localService.isBusinessOptionEnabled(this.businessId, BusinessEnabledOption.LockPreviewPrintReceiptOfDefault);
    if (!this.selectedStatus || this.selectedStatus == '')
      this.selectedStatus = '0';
    this.onGetBills();
  }

  onGetBills() {
    this.billingManagementService.getBills(this.businessId, this.tokenNumber, this.selectedStatus, this.wrapper ? this.wrapper.paging : null, this.isExcluded, this.selectedUserId).subscribe(result => {
      this.wrapper = result;
    });
  }

  onUserUpdated(e) {
    this.selectedUserId = e;
    this.onLoad();
  }

  onOpenBilling(id: string) {
    this.router.navigate(['/billing-view' + this.localService.basicParamsString, this.businessId, id]);
  }

  onSearchToken(e) {
    this.tokenNumber = e;
    this.onLoad();
  }

  onAction(index: number, key?: string) {
    switch (index) {
      case 1: {
        const item = this.wrapper.items.find(x => x.key == key);
        this.selectedId = key;
        this.actionTitle = item?.v2 ?? '';
        const customerTemplateIds = this.localService.getCustomerCopiesTemplateIds();
        this.moreActionItems = [
          {
            isSelected: this.interactionType != InteractionType.Bill_PnixSoft && customerTemplateIds.length == 1 ? false : true,
            key: '1',
            v1: this.localService.languageContent.billings['preview_customer_receipt'],
            v2: 'pageview',
            v3: this.interactionType != InteractionType.Bill_PnixSoft && customerTemplateIds.length == 1 ? ['/rv', this.ctryCode, customerTemplateIds[0], key].join('/') : key
          } as KeyValues5,
          {
            key: '2',
            isSelected: true,
            isReadonly: !this.isSendToPhoneEnabled,
            v1: this.localService.languageContent.common['send_to_phone'],
            v2: 'send_to_mobile',
            v3: key
          } as KeyValues5,
          {
            key: '3',
            isReadonly: !this.isDedicatedStorageAvailable,
            v1: this.localService.languageContent.billing['attach_files'],
            v2: 'attach_file',
            v3: ['/receipt-files' + this.localService.basicParamsString, this.businessId, key].join('/')
          } as KeyValues5,
          {
            key: '4',
            v1: this.localService.languageContent.billing['receipt_custom_labels'],
            v2: 'label',
            v3: ['/receipt-custom-labels' + this.localService.basicParamsString, this.businessId, key].join('/')
          } as KeyValues5,
        ];
        this.isActionPopupOpen = true;
      } break;
      case 2: {
        this.isOpenConfirmationBox = true;
      } break;
      case 4: {
        this.selectedId = key;
        this.isOpenSendToPhone = true;
      } break;
      case 5: {
        this.router.navigate(['/receipt-custom-labels' + this.localService.basicParamsString, this.businessId, key]);
      } break;
    }
  }

  onMoreActionClicked(keyId: KeyValueId) {
    switch (keyId.key) {
      case '1': {
        const modalRef = this.modalService.open(ReceiptTemplateSelectorComponent);
        modalRef.componentInstance.receiptId = keyId.value;
        modalRef.componentInstance.isLoadTemplate = this.interactionType == InteractionType.Bill_PnixSoft;
        modalRef.componentInstance.businessId = this.businessId;
      } break;
      case '2': {
        this.onAction(4, keyId.value);
      } break;
    }
  }

  onDelete(result: any) {
    this.isOpenConfirmationBox = false;
    if (result && result.event == TriggeredEvent.Ok) {
      this.isShowOtpPopup = true;
    }
  }

  onVerifiedOtp(e: any) {
    this.isShowOtpPopup = false;

    this.billingManagementService.deleteBills(this.businessId, this.tokenNumber, this.selectedStatus, this.wrapper ? this.wrapper.paging : null, this.isExcluded, this.selectedUserId).subscribe(result => {
      this.localService.showInformationByStatus(result.status);
      if (result.status == Status.Success) {
        this.onLoad();
      }
    });
  }
}
